import { api } from "./apiClient";

export const authService = {
  signIn: (credentials) => api.post("/auth/sign-in", credentials),
  signupToken: () => api.get("/auth/signup-token"),
  register: (profile) => api.post("/auth/register", profile),
  activate: (token) => api.post("/auth/activate", { token }),
  me: (token) => api.get("/me", { token }),
  requestReset: (email) => api.post("/auth/password/reset-request", { email }),
  confirmReset: (token, password) => api.post("/auth/password/reset-confirm", { token, password }),
};

export const eventService = {
  list: (filters, options) => api.get("/events", { ...options, query: filters }),
  get: (id, options) => api.get(`/events/${encodeURIComponent(id)}`, options),
  similar: (id, options) => api.get(`/events/${encodeURIComponent(id)}/similar`, options),
};

export const gigService = {
  list: (filters, options) => api.get("/gigs", { ...options, query: filters }),
  forEvent: (eventId, options) => api.get(`/events/${encodeURIComponent(eventId)}/gig`, options),
  create: (gig, options) => api.post("/gigs", gig, options),
  update: (id, gig, options) => api.patch(`/gigs/${encodeURIComponent(id)}`, gig, options),
  apply: (id, application, options) => api.post(`/gigs/${encodeURIComponent(id)}/applications`, application, options),
};

export const directoryService = {
  artists: (filters, options) => api.get("/artists", { ...options, query: filters }),
  venues: (filters, options) => api.get("/venues", { ...options, query: filters }),
  studios: (filters, options) => api.get("/studios", { ...options, query: filters }),
  media: (filters, options) => api.get("/media", { ...options, query: filters, token: null }),
};

export const venueService = {
  get: (id, options) => api.get(`/venues/${encodeURIComponent(id)}`, options),
  events: (id, options) => api.get(`/venues/${encodeURIComponent(id)}/events`, options),
  reviews: (id, options) => api.get(`/venues/${encodeURIComponent(id)}/reviews`, options),
  similar: (id, options) => api.get(`/venues/${encodeURIComponent(id)}/similar`, options),
};

export const reviewService = {
  eligibility: (targetType, targetId, options) =>
    api.get("/reviews/eligibility", { ...options, query: { targetType, targetId } }),
  create: (review, options) => api.post("/reviews", review, options),
};

export const studioDirectoryService = {
  get: (id, options) => api.get(`/studios/${encodeURIComponent(id)}`, options),
  reviews: (id, options) => api.get(`/studios/${encodeURIComponent(id)}/reviews`, options),
  similar: (id, options) => api.get(`/studios/${encodeURIComponent(id)}/similar`, options),
};

export const mediaDirectoryService = {
  get: (id, options) => api.get(`/media/${encodeURIComponent(id)}`, options),
  reviews: (id, options) => api.get(`/media/${encodeURIComponent(id)}/reviews`, options),
  similar: (id, options) => api.get(`/media/${encodeURIComponent(id)}/similar`, options),
};

export const studioService = {
  createBundle: (bundle, options) => api.post("/studio-bundles", bundle, options),
  requestBooking: (studioId, request, options) =>
    api.post(`/studios/${encodeURIComponent(studioId)}/booking-requests`, request, options),
};

let threadsRequest = null;

export const messageService = {
  // App-level unread badges and the Inbox mount at the same time. Share their
  // in-flight request so opening the Inbox does not perform the same lookup twice.
  threads: (options) => {
    if (options) return api.get("/messages/threads", options);
    if (!threadsRequest) {
      threadsRequest = api.get("/messages/threads").finally(() => {
        threadsRequest = null;
      });
    }
    return threadsRequest;
  },
  startThread: (recipient, options) => api.post("/messages/threads", recipient, options),
  messages: (threadId, options) => api.get(`/messages/threads/${encodeURIComponent(threadId)}`, options),
  send: (threadId, message, options) =>
    api.post(`/messages/threads/${encodeURIComponent(threadId)}/messages`, message, options),
  respondToInvitation: (invitationId, status, options) =>
    api.post(`/invitations/${encodeURIComponent(invitationId)}/respond`, { status }, options),
};

export const pageService = {
  create: (type, page, options) => api.post(`/${type}s`, page, options),
  update: (type, id, page, options) =>
    api.patch(`/${type}s/${encodeURIComponent(id)}`, page, options),
  remove: (type, id, options) =>
    api.delete(`/${type}s/${encodeURIComponent(id)}`, options),
};

export const adminService = {
  reports: (filters, options) => api.get("/admin/reports", { ...options, query: filters }),
  updateReport: (id, patch, options) => api.patch(`/admin/reports/${encodeURIComponent(id)}`, patch, options),
};

export const profileService = {
  me: (options) => api.get("/me", options),
  update: (patch, options) => api.patch("/me", patch, options),
  joinProWaitlist: (options) => api.post("/pro-waitlist", {}, options),
};

export const followService = {
  list: (options) => api.get("/follows", options),
  listForPage: (subjectType, subjectId, options) =>
    api.get("/follows", { ...options, query: { subjectType, subjectId } }),
  create: (subjectType, subjectId, options) =>
    api.post("/follows", { subjectType, subjectId }, options),
  remove: (subjectType, subjectId, options) =>
    api.delete(`/follows/${encodeURIComponent(subjectType)}/${encodeURIComponent(subjectId)}`, options),
};
